import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState, mapGetters } from "vuex";
import { mapFields } from "@joandvgv/vuex-map-fields";
import { UPDATE_ACCOUNT_PERSONAL_DETAILS } from "@Broker/@Modules/main/store/account/account-actions";
import Err from "@Broker/@Routes/error";
import { AGENT_IS_OWNER } from "../../../../store/application-getters";
import { isEmpty, pickBy } from "lodash";
import { validationMixin } from "vuelidate";
import { requiredAddressValidation } from "@Shared/@Utils/validation-rules";
import AddressSection from "@Shared/components/sections/new-sections/address-section.vue";
import Field from "@Shared/components/sections/field.vue";
import MaterialInput from "@Shared/components/inputs/material-input.vue";
import { LOAD_FILOGIX_DETAILS, UPDATE_FILOGIX_DETAILS } from "@Broker/@Modules/settings/store/settings-actions";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "Agent",
  components: {
    AddressSection,
    Field,
    MaterialInput
  },
  mixins: [validationMixin],
  props: {
    applicationId: {
      type: Number,
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    },
    agentUsername: {
      type: String,
      required: true
    }
  },
  validations: {
    agent: {
      address: requiredAddressValidation()
    }
  },
  data() {
    return {
      localFilogixDetails: {},
      loadingDetails: true
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapFields("ApplicationStore", ["participants.agent"])), mapGetters("ApplicationStore", [AGENT_IS_OWNER])), mapState("AccountStore", {
    currentUsername(state) {
      return state.userDetails.username;
    },
    accountDetails(state) {
      return state.accountDetails;
    },
    userDetails(state) {
      return state.userDetails;
    }
  })), mapState("SettingsStore", ["filogixDetails"])), {}, {
    isOwner() {
      return this.AGENT_IS_OWNER(this.agentUsername);
    },
    missingAgentDetails() {
      return isEmpty(pickBy(this.agent, (value, key) => key !== "address"));
    },
    addressCustomExpressions() {
      return {
        line1: "agent.address.line1",
        "street-number": "agent.address.street-number",
        "street-name": "agent.address.street-name",
        city: "agent.address.city",
        province: "agent.address.province",
        "postal-code": "agent.address.postal-code"
      };
    }
  }),
  async mounted() {
    this.loadingDetails = true;
    await this.LOAD_FILOGIX_DETAILS({
      applicationId: this.applicationId,
      clientUsername: this.clientUsername
    });
    this.$set(this, "localFilogixDetails", this.filogixDetails);
    this.loadingDetails = false;
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions("SettingsStore", [LOAD_FILOGIX_DETAILS, UPDATE_FILOGIX_DETAILS])), mapActions("AccountStore", [UPDATE_ACCOUNT_PERSONAL_DETAILS])), {}, {
    async handleSubmit() {
      if (this.$v.$invalid) return;
      const submitButton = $(this.$refs.submitButton).animateButton();
      submitButton.animate("start");
      try {
        await this.UPDATE_FILOGIX_DETAILS(this.localFilogixDetails);
        const {
          timezone
        } = this.accountDetails;
        this.UPDATE_ACCOUNT_PERSONAL_DETAILS({
          details: _objectSpread(_objectSpread({}, this.agent), {}, {
            timezone
          })
        });
        submitButton.animate("finish");
      } catch (e) {
        Err.handle(e, {}, this.$t("direct-to-lender.participants.errorUpdatingAgent"));
        submitButton.animate("finish", "failed");
      }
    }
  })
});